/* @flow */
import { getterFromKeyPath } from 'trustar/utils';

export const roles = getterFromKeyPath(['roles', 'roles']);
export const loading = getterFromKeyPath(['roles', 'loading']);



// WEBPACK FOOTER //
// ./src/app/modules/roles/getters.js